import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ShieldCheck, ArrowRight } from "lucide-react";

const RED = "#E11D2B";

const StatusGauge = ({ value }) => (
  <div className="relative h-28 w-28">
    <svg viewBox="0 0 100 100" className="h-full w-full -rotate-90">
      <circle cx="50" cy="50" r="42" fill="none" stroke="#242a35" strokeWidth="8" />
      <circle cx="50" cy="50" r="42" fill="none" stroke={RED} strokeWidth="8" strokeLinecap="round"
        strokeDasharray={`${(value / 100) * 264} 264`}
        style={{ filter: "drop-shadow(0 0 6px rgba(225,29,43,0.8))", transition: "stroke-dasharray 1.2s ease" }} />
    </svg>
    <div className="absolute inset-0 grid place-items-center">
      <span className="font-mono text-xl font-bold text-white">{Math.round(value)}%</span>
    </div>
  </div>
);

export const RepcoClientPanel = () => {
  const [val, setVal] = useState(0);
  useEffect(() => {
    const t = setTimeout(() => setVal(70), 400);
    const id = setInterval(() => setVal((v) => 64 + Math.random() * 14), 3000);
    return () => { clearTimeout(t); clearInterval(id); };
  }, []);

  return (
    <section data-testid="repco-client-panel" className="max-w-7xl mx-auto px-4 lg:px-8 py-20">
      <div className="flex items-center gap-3 mb-3">
        <span className="h-px w-10 bg-brand-red" />
        <span className="font-mono text-xs uppercase tracking-[0.4em] text-brand-red">Performance Partners &amp; Service</span>
        <span className="h-px w-10 bg-brand-red" />
      </div>
      <div className="mt-8 grid grid-cols-1 lg:grid-cols-5 gap-5">
        {/* Repco integration */}
        <div data-testid="repco-section" className="lg:col-span-3 hud-panel-silver rounded-xl p-6 sm:p-8 flex flex-col sm:flex-row items-center gap-7 red-sweep">
          <img src="/repco-badge.png" alt="Repco Authorised Service" className="w-48 sm:w-56 shrink-0 drop-shadow-[0_0_18px_rgba(225,29,43,0.25)]" />
          <div>
            <h2 className="font-tech uppercase text-2xl text-white tracking-wide leading-tight">
              Backed by Australia&apos;s largest aftermarket network
            </h2>
            <p className="mt-3 text-sm text-zinc-400 leading-relaxed">
              As a Repco Authorised Service centre, every job we do is backed by a nationwide warranty,
              quality Repco parts, and manufacturer-spec logbook servicing — your new-car warranty stays intact.
            </p>
            <div className="mt-4 flex flex-wrap gap-2">
              {["Nationwide warranty", "Quality parts", "Logbook safe"].map((t) => (
                <span key={t} className="inline-flex items-center gap-1.5 border border-brand-red/40 bg-brand-red/10 px-3 py-1 font-mono text-[10px] uppercase tracking-widest text-brand-red">
                  <ShieldCheck className="h-3 w-3" /> {t}
                </span>
              ))}
            </div>
          </div>
        </div>

        {/* Client portal */}
        <div data-testid="client-portal-section" className="lg:col-span-2 hud-panel rounded-xl p-6 sm:p-8 flex flex-col items-center justify-center text-center gap-4">
          <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-zinc-400">Client portal · Your vehicle status</div>
          <StatusGauge value={val} />
          <p className="text-xs text-zinc-400 max-w-xs">
            Track your next service, download your digital logbook and rebook in one tap.
          </p>
          <Link
            to="/account"
            data-testid="client-portal-login-btn"
            className="glow-btn inline-flex items-center gap-2 px-7 py-3 bg-brand-red text-white font-bold uppercase tracking-wider text-sm rounded"
          >
            Customer login <ArrowRight className="h-4 w-4" />
          </Link>
        </div>
      </div>
    </section>
  );
};
